import { Doughnut, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels';
//Chart.plugins.unregister(ChartDataLabels);
Chart.helpers.merge(Chart.defaults.global.plugins.datalabels, {
  color: '#FFF'
});

const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  data() {
    return {
      // options: {
      //   rotation: 0,
      //   legend: false,
      //   layout: {
      //     padding: 32
      //   },
      //   plugins: {
      //     datalabels: {
      //       align: 'end',
      //       anchor: 'end',
      //       backgroundColor: null,
      //       borderColor: null,
      //       borderRadius: 4,
      //       borderWidth: 1,
      //       color: '#777',
      //       font: {
      //         size: 12
      //       },
      //       //offset: 16,
      //       padding: 0,
      //       formatter: function(value, context) {
      //         return  value + '%';
      //       }
      //     }
      //   }
      // }
      options: {
        legendCallback: function(chart) {
          // Return the HTML string here.
      },
        plugins: {
          datalabels: {
            padding: 0,
            // align: function(context) {
            //   var index = context.dataIndex;
            //   var value = context.dataset.data[index];
            //   var invert = Math.abs(value) <= 1;
            //   return value < 1 ? 'end' : 'start'
            // },
            // anchor: 'end',
            formatter: function(value, context) {
              return value + '%';
              //return this.$t('1825',{str1:Math.round(value)})
            },
            // textAlign: "center",
            font: {
              size: 14,
              // family: "noto-regular",
            }
          }
        },
        legend: {
          display: false
        },
        animation: {
          animateScale: true,
          animateRotate: true
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  // ready () {
  //   this.legendMarkup = this._chart.generateLegend()
  //  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    
    Chart.plugins.register(ChartDataLabels);
    this.addPlugin(ChartDataLabels);
    this.renderChart(this.chartData, this.options)
    //document.getElementById('chartjsLegend').innerHTML = this.myChart.generateLegend();
  }
}
